import React from "react";
import { CheckBox, InputGroup } from "../../common/inputs";
import { UserSettings } from "../../../models/user";

type GradesQuizzesProps = {
  settings: UserSettings;
  setSettings: any;
  loading: boolean;
};
const GradesQuizzes: React.FC<GradesQuizzesProps> = ({
  settings,
  setSettings,
  loading = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const setting = e.target.id as keyof UserSettings;
    let value = e.target.checked;
    const reverted = e.target.getAttribute("data-reverted");
    if (reverted === "true") {
      value = !value;
    }
    setSettings(setting, value);
  };
  const handleTextChange = (value: string | null) => {
    const setting = "retakes_limit";
    ///accept only numbers
    if (value === "" || value === null) {
      setSettings(setting, "");
      return;
    }
    if (!/^\d+$/.test(value)) {
      return;
    }
    let value_num = parseInt(value);
    if (value_num > 50) {
      value = "50";
    }
    setSettings(setting, value);
  };
  return (
    <div className="setting_panel">
      <h4>Grades & Quizzes Preferences</h4>
      <div className="row">
        <div className="col-md-7 text-white">
          <CheckBox
            label="Show auto-graded quizzes to students"
            id="hide_quizzes"
            handleChange={handleChange}
            checked={settings.hide_quizzes}
            reverted
            classes="mb-3"
            help="This option enables you to choose whether to show or hide auto-graded quizzes from your students. If you disable this option, students will no longer be able to view auto-graded quizzes in books. Please note that this setting applies to all your groups."
          />
          <CheckBox
            label="Automatically Allow Retakes"
            id="allow_retakes"
            handleChange={handleChange}
            checked={settings.allow_retakes === true}
            classes="mb-3"
            help="This option enables your students to start a retake automatically without requiring manual approval from you. Please note that this setting applies to all your groups."
          />
          <InputGroup
            title="Limit Number of Retakes"
            initial_value={settings.retakes_limit?.toString() || ""}
            id="retakes_limit"
            handleUpdate={handleTextChange}
            classes="mb-3 ml-3"
            value_label="Times"
            loading={loading}
            error={
              settings.retakes_limit && settings.retakes_limit >= 50
                ? "Retake limit cannot exceed 50."
                : undefined
            }
            help="This option enables you to limit the number of retakes your students can do for each quiz. Automatically Allow Retakes must be enabled for this setting to take effect. Please note that this setting applies to all your groups."
          />
        </div>
      </div>
    </div>
  );
};

export default GradesQuizzes;
